import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Checkbox from '@material-ui/core/Checkbox';

const statusColors = {
    alert: 'var(--color-yellow-500)',
    success: 'var(--color-green-500)',
    pause: 'var(--color-gray-500)',
};

const ContractCardWrapper = styled.div`
    display: flex;
    width: fit-content;
    position: relative;
    padding: 0 24px;
    
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 52px;
    

    background: #FFFFFF;
    /* default/gray/400 */
    border: 1px solid #CCD6E0;
    box-sizing: border-box;
    /* shadow-md */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.06);
    border-radius: 8px;
`;

const ComponentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    height: fit-content;
`;

const ContractContent = styled.div`
    display: grid;
    align-self: center;
    grid-auto-flow: column;
    column-gap: 32px;
    //grid-template-columns: repeat(5, 150px);
    grid-template-columns: 100px 150px 100px 150px 150px 30px;

    > div {
      display: flex;
      align-items: center;
    }
`;

const HeadingWrapper = styled.div`
    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height, or 100% */
    text-align: right;
    
    /* default/gray/900 */
    color: #1D2129;
`;

const StatusColor = styled.div`
    position: relative;
    width: 8px;    
    left: -24px;
    border-radius: 22px 0 0 22px;
`;

const StatusText = styled.text`
    color: ${props => props.color};
    //width: 250px;
    white-space: nowrap;
    text-align: center;
    overflow: hidden;
    align-self: center;
    text-overflow: ellipsis;
    
    //:hover {
    //    overflow: visible;
    //}
`;

function ContractsLineItem(
    {
        id,
        number,
        status,
        duration,
        monthlyRate,
        totalCashPrice,
        color,
        actionsComponent,
        isSelected,
        selectable,
        onSelected,
    }
) {
    return (
        <ComponentWrapper>

            {
                selectable &&
                <Checkbox
                    value={id}
                    checked={isSelected}
                    onChange={onSelected}
                    color="primary"
                    inputProps={{'aria-label': 'primary checkbox'}}
                />
            }

            <ContractCardWrapper>
                <StatusColor style={{background: `${color}`}}/>
                <ContractContent>
                    {/*Id */}
                    <div
                        style={{
                            fontWeight: 500,
                            fontSize: '18px',
                            lineHeight: '18px'
                        }}
                    >
                        {number}
                    </div>
                    {/*Status*/}
                    <StatusText color={color} name={status}>
                        {status}
                    </StatusText>
                    {/*Duration*/}
                    <div>{duration}</div>
                    {/*Monthly Rate*/}
                    <div>{monthlyRate}</div>
                    {/*Total Cash Price*/}
                    <div>{totalCashPrice}</div>

                    <div>
                        {actionsComponent}
                    </div>
                </ContractContent>
            </ContractCardWrapper>
        </ComponentWrapper>
    );
}

ContractsLineItem.propTypes = {
    id: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    duration: PropTypes.string.isRequired,
    monthlyRate: PropTypes.string.isRequired,
    totalCashPrice: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    actionsComponent: PropTypes.object,
    isSelected: PropTypes.bool,
    selectable: PropTypes.bool
};
ContractsLineItem.defaultProps = {};

export default ContractsLineItem;
